/**
 * Public marketing / support identifiers (build-time via Create React App env).
 *
 * Set `REACT_APP_SUPPORT_EMAIL` in `.env` or the hosting provider’s env for production.
 */
const raw = typeof process !== 'undefined' ? process.env.REACT_APP_SUPPORT_EMAIL : undefined;
const trimmed = typeof raw === 'string' ? raw.trim() : '';

export const SUPPORT_EMAIL = trimmed !== '' ? trimmed : 'support@parachuteiq.com';

export const MAILTO_SUPPORT_HREF = `mailto:${encodeURIComponent(SUPPORT_EMAIL)}`;
